import React, { useState, useEffect } from "react";
// Use Forms
import { useForm } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
// React Bootstrap
import { Form, Button, Col, Accordion, Card } from "react-bootstrap";

const FormDescripcionProyecto = ({ defaultValues, submissionHandler }) => {
  const [validated] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: defaultValues,
  });

  // On submit del formulario
  const onSubmit = (data) => {
    submissionHandler(data);
  };

  return (
    <Form noValidate validated={validated} onSubmit={handleSubmit(onSubmit)} className="m-3">
      <Form.Row>
        <small className="mb-3">
          Los campos con un <b>*</b> deben de ser rellenados.
        </small>
      </Form.Row>
      <Accordion defaultActiveKey="0" className="mb-2">
        <Card>
          <Accordion.Toggle as={Card.Header} eventKey="0">
            Descripción del proyecto
          </Accordion.Toggle>
          <Accordion.Collapse eventKey="0">
            <Card.Body>
              <Form.Row>
                <Form.Group as={Col} xs={12} md controlId="nSister-project">
                  <Form.Label>{"Número de hermanas"}</Form.Label>
                  <Form.Control name="nSister" placeholder={"Número"} type="number" isInvalid={errors?.nSister} {...register("nSister", {})} />
                  <ErrorMessage errors={errors} name="nSister" render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
                </Form.Group>

                <Form.Group as={Col} xs={12} md controlId="nLay-project">
                  <Form.Label>{"Número de laicos"}</Form.Label>
                  <Form.Control name="nLay" placeholder={"Número"} type="number" isInvalid={errors?.nLay} {...register("nLay", {})} />
                  <ErrorMessage errors={errors} name="nLay" render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
                </Form.Group>
                <Form.Group as={Col} xs={12} md controlId="nVolunteer-project">
                  <Form.Label>{"Número de voluntarios"}</Form.Label>
                  <Form.Control name="nLay" placeholder={"Número"} type="number" isInvalid={errors?.nVolunteer} {...register("nVolunteer", {})} />
                  <ErrorMessage errors={errors} name="nVolunteer" render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
                </Form.Group>
              </Form.Row>
              <Form.Row>
                <Form.Group as={Col} xs={12} md controlId="objective-project">
                  <Form.Label>{"Objetivo"}</Form.Label>
                  <Form.Control
                    type="text"
                    as="textarea"
                    isInvalid={errors?.objective}
                    {...register("objective", {
                      maxLength: {
                        value: 400,
                        message: "El máximo de caracteres es 400",
                      },
                    })}
                  />

                  <ErrorMessage errors={errors} name="objective" render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
                </Form.Group>
              </Form.Row>
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>

      <Form.Group>
        <Button type="submit" variant="outline-primary" className="btn btn-block mt-5">
          Guardar
        </Button>
      </Form.Group>
    </Form>
  );
};

export default FormDescripcionProyecto;
